import { memo } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { PaymentTemplate } from 'components/templates/PaymentTemplate';
import { CircularProgress, Backdrop } from '@material-ui/core';
import classes from 'components/templates/override.module.scss';
import { usePayPalClientId } from 'hooks/payment/UsePayPalClientId';

type Props = {};

export const Payment = memo((_props: Props) => {
	const { clientId, loading } = usePayPalClientId();

	if (loading) {
		return (
			<Backdrop className={classes.backdrop} open={loading}>
				<CircularProgress color="inherit" />
			</Backdrop>
		);
	}

	return (
		<PayPalScriptProvider
			options={{
				'client-id': clientId,
				components: 'buttons,hosted-fields',
				intent: 'authorize',
				currency: 'JPY',
				'data-namespace': 'paypal_sdk_payment',
			}}
		>
			<PaymentTemplate />
		</PayPalScriptProvider>
	);
});
